import { isObject, get } from 'lodash'
import { updateUserPrivileges } from 'common/actionCreators/user'
import { IDispatch } from 'common/interfaces.d'
import { STORE_NAME as ACCESS_TOKEN_STORE_NAME } from 'common/reducers/accessToken'

export function getMerchantUuid(store: any): string {
  return (
    store[ACCESS_TOKEN_STORE_NAME].get('merchantUuid') ||
    store[ACCESS_TOKEN_STORE_NAME].get('uuid')
  )
}

export const findAndDispatchUserPrivileges = (
  response: any,
  dispatch: IDispatch
): void => {
  const privileges: any = {}
  const registration: number | undefined = get(
    response,
    'registration',
    undefined
  )
  const possibleActions: object | undefined = get(
    response,
    'possibleActions',
    undefined
  )

  if (typeof registration === 'number') {
    privileges.registration = {
      companyRegistrationStatus: registration
    }
  }

  if (isObject(possibleActions) === true) {
    Object.keys(possibleActions).forEach(key => {
      privileges[key] = possibleActions[key]
    })
  }

  if (Object.keys(privileges).length > 0) {
    dispatch(updateUserPrivileges(privileges))
  }
}
